export const constant = {
  phoneSupportHeading: 'Phone Support',
};
